/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Status_Cleaning_UpInputs */

const en_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cleaning Up`)
};

const fr_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyage`)
};

const de_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufräumen`)
};

const it_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulizia`)
};

const ru_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уборка`)
};

const es_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpieza`)
};

const zh_cn2_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清理`)
};

const ja_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリーンアップ`)
};

const hi_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सफाई`)
};

const pt_pt2_iconik_publish_status_cleaning_up = /** @type {(inputs: Iconik_Publish_Status_Cleaning_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpeza`)
};

/**
* | output |
* | --- |
* | "Cleaning Up" |
*
* @param {Iconik_Publish_Status_Cleaning_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_status_cleaning_up = /** @type {((inputs?: Iconik_Publish_Status_Cleaning_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Status_Cleaning_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_status_cleaning_up(inputs)
	if (locale === "de") return de_iconik_publish_status_cleaning_up(inputs)
	if (locale === "it") return it_iconik_publish_status_cleaning_up(inputs)
	if (locale === "ru") return ru_iconik_publish_status_cleaning_up(inputs)
	if (locale === "es") return es_iconik_publish_status_cleaning_up(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_status_cleaning_up(inputs)
	if (locale === "ja") return ja_iconik_publish_status_cleaning_up(inputs)
	if (locale === "hi") return hi_iconik_publish_status_cleaning_up(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_status_cleaning_up(inputs)
	return en_iconik_publish_status_cleaning_up(inputs)
});